import React from 'react'
import {Bar} from 'react-chartjs-2'

class Graph extends React.Component {
  render () {
    return(
      <div style={{height: '100%', width:'100%', maxheight:'500px', margin: 'auto'}}>
        <Bar
          data={{
            datasets: [{
              data: this.props.data,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)'
              ],
              borderColor: [
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)'
              ],
              borderWidth: 2,
            }],
            labels: ["Trucks", "Rigs", "Plant", "Vehicles"]
          }}
          options={{
            maintainAspectRatio:false,
            legend: {
              display: false,
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }}
        />
      </div>
    )
  }
}

export default Graph;
